// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getMasterBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/master-bids`,
    deleteBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding`,
    lastBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/last-bid`,
    otherMarketsBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/other-market-bids`,
    bidRequest: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/bid-request`,
    createBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding`,
    resultId: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/result-id`,
    secondaryBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/secondary-bid`,
    logs: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/logs`,
    createNote: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/note`,
    getNotes: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/note`,
    deleteNote: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/note`,
    fetchResult: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/fetch-result`,
    panic: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/panic`,
    getOverallCapacity: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/overall-capacity`,
    getBidsForBulkBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/bulk-bids`,
    createBulkBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/bulk-bids`,
    getBidsForPost: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/bids-for-post`,
    postBidEnerginet: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/post-bids`,
    getLastDocPosted: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/last-post-doc-log`,
    postResourceSchedule: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/post-resource-schedule`,
    marketEnabled: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/market-enabled`,
    getBids: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding`,
    updatePostedEnergyBid: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/post-updated-energy-bid`,
    datahubCostEnergy: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/datahub-cost-energy`,
    totalBidCapacity: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/total-bid-capacity`,
    getEnergyBidType: `/${BASE_URL_BIDDING_SERVICE}/admin/bidding/energy-bid-type`,
};

const GetMasterBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getMasterBids}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteBid = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteBid}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetLastBid = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.lastBid}`, { params }).then(callback).catch(error).finally(next);
};

const GetOtherMarketsBid = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.otherMarketsBids}`, { params }).then(callback).catch(error).finally(next);
};

const GetBidRequest = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bidRequest}`, { params }).then(callback).catch(error).finally(next);
};

const CreateBid = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.createBid}`, payload).then(callback).catch(error).finally(next);
};

const UpdateResultId = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.resultId}/${id}`, payload).then(callback).catch(error).finally(next);
};

const CreateSecondaryBid = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.secondaryBid}/${id}`, payload).then(callback).catch(error).finally(next);
};

const GetLogs = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.logs}/${bidId}`).then(callback).catch(error).finally(next);
};

const CreateNote = (bidId, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.createNote}/${bidId}`, payload).then(callback).catch(error).finally(next);
};

const GetNotes = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getNotes}/${bidId}`).then(callback).catch(error).finally(next);
};

const DeleteNote = (bidId, params, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteNote}/${bidId}`, { params }).then(callback).catch(error).finally(next);
};

const FetchResult = (bidId, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.fetchResult}/${bidId}`).then(callback).catch(error).finally(next);
};

const UpdatePanicHours = (bidId, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.panic}/${bidId}`, payload).then(callback).catch(error).finally(next);
};

const GetOverallCapacity = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getOverallCapacity}`, { params }).then(callback).catch(error).finally(next);
};

const GetBidsForBulkBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBidsForBulkBids}`, { params }).then(callback).catch(error).finally(next);
};

const CreateBulkBids = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.createBulkBids}`, payload).then(callback).catch(error).finally(next);
};

const GetBidsForPost = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBidsForPost}`, { params }).then(callback).catch(error).finally(next);
};

const PostBidEnerginet = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.postBidEnerginet}`, payload).then(callback).catch(error).finally(next);
};

const GetLastDocPosted = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getLastDocPosted}`, { params }).then(callback).catch(error).finally(next);
};

const PostResourceSchedule = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.postResourceSchedule}`, payload).then(callback).catch(error).finally(next);
};

const GetMarketEnabledCusLicenseIns = (market, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.marketEnabled}/${market}`).then(callback).catch(error).finally(next);
};

const GetBids = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBids}`, { params }).then(callback).catch(error).finally(next);
};

const UpdatePostedEnergyBid = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.updatePostedEnergyBid}`, payload).then(callback).catch(error).finally(next);
};

const GetDatahubCostEnergy = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.datahubCostEnergy}`, { params }).then(callback).catch(error).finally(next);
};

const TotalBidCapacity = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.totalBidCapacity}`, { params }).then(callback).catch(error).finally(next);
};

const GetEnergyBidType = (bidId, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getEnergyBidType}/${bidId}`, { params }).then(callback).catch(error).finally(next);
};

export const AdminBiddingService = {
    GetMasterBids,
    DeleteBid,
    GetLastBid,
    GetOtherMarketsBid,
    GetBidRequest,
    CreateBid,
    UpdateResultId,
    CreateSecondaryBid,
    GetLogs,
    CreateNote,
    GetNotes,
    DeleteNote,
    FetchResult,
    UpdatePanicHours,
    GetOverallCapacity,
    GetBidsForBulkBids,
    CreateBulkBids,
    GetBidsForPost,
    PostBidEnerginet,
    GetLastDocPosted,
    PostResourceSchedule,
    GetMarketEnabledCusLicenseIns,
    GetBids,
    UpdatePostedEnergyBid,
    GetDatahubCostEnergy,
    TotalBidCapacity,
    GetEnergyBidType,
};
